module.exports = __webpack_public_path__ + "static/media/CHAP01-EXERGUE-SAMCHAKA.cfa2f6d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/CHAP01-EXERGUE-SAMCHAKA.png
// module id = 250
// module chunks = 0